// Shopify Licensing System - Music licensing interface with Shopify Cart API integration

const albumColors = {
    "Ronald Jenkees": {
        primaryColor: "#2c1810",
        secondaryColor: "#b69b8c",
        textColor: "#ffffff",
        accentColor: "#ffd700",
        year: "2007"
    },
    "Disorganized Fun": {
        primaryColor: "#4a2c2e",
        secondaryColor: "#c17f83",
        textColor: "#ffffff",
        accentColor: "#ffd700",
        year: "2009"
    },
    "Days Away": {
        primaryColor: "#1a1e3c",
        secondaryColor: "#8494cf",
        textColor: "#ffffff",
        accentColor: "#ffd700",
        year: "2012"
    },
    "Alpha Numeric": {
        primaryColor: "#e6c405",
        secondaryColor: "#8494b7",
        textColor: "#2c2c2c",
        accentColor: "#ffffff",
        year: "2014"
    },
    "Make It Fun Vol. 1": {
        primaryColor: "#181713",
        secondaryColor: "#d6b214",
        textColor: "#f1f9ec",
        accentColor: "#a9b2ff",
        year: "2016"
    },
    "Rhodes Deep": {
        primaryColor: "#2a1b35",
        secondaryColor: "#ff8e3c",
        textColor: "#ff9ec7",
        accentColor: "#ffd700",
        year: "2017"
    },
    "Wonder And Flow": {
        primaryColor: "#a7a8a2",
        secondaryColor: "#faf9f5",
        textColor: "#698695",
        accentColor: "#e1d8ce",
        year: "2024"
    }
};

let albums = [
    {
        name: "Ronald Jenkees",
        productId: "9856772800787",
        variantId: "50547500941587",
        cover: "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJCD1_600_2.jpg?v=1755810437",
        tracks: [
            { title: "Derty", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_01._Derty_preview.mp3" },
            { title: "Neptune", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_02._Neptune_preview.mp3" },
            { title: "Canon In D Remix", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_03._Canon_in_D_Remix_preview.mp3" },
            { title: "Clutter", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_04._Clutter_preview.mp3" },
            { title: "Super-Fun", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_05._Super-Fun_preview.mp3" },
            { title: "Snap", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_07._Snap_preview.mp3" },
            { title: "The Sunfish Song", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_08._The_Sunfish_Song_preview.mp3" },
            { title: "Loui", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_09._Loui_preview.mp3" },
            { title: "Gold Spinners", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_10._Gold_Spinners_preview.mp3" },
            { title: "Remix To A Remix", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_11._Remix_To_A_Remix_preview.mp3" },
            { title: "Almost Undamaged", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_12._Almost_Undamaged_preview.mp3" },
            { title: "56K (Rap)", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_13._56K_RAP_preview.mp3" },
            { title: "Ain't No Thang (Rap)", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_14._Aint_No_Thang_RAP_preview.mp3" }
        ]
    },
    {
        name: "Disorganized Fun",
        productId: "9856772374803",
        variantId: "50547493273875",
        cover: "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJCD2_600.jpg?v=1755810202",
        tracks: [
            { title: "Disorganized Fun", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_01._Disorganized_Fun_preview.mp3" },
            { title: "Fifteen Fifty", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_02._Fifteen_Fifty_preview.mp3" },
            { title: "Guitar Sound", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_03._Guitar_Sound_preview.mp3" },
            { title: "Synth One", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_04._Synth_One_preview.mp3" },
            { title: "Throwing Fire", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_05._Throwing_Fire_preview.mp3" },
            { title: "Minimal MC", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_06._Minimal_MC_preview.mp3" },
            { title: "Stay Crunchy", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_07._Stay_Crunchy_preview.mp3" },
            { title: "Inverted Mean", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_08._Inverted_Mean_preview.mp3" },
            { title: "Outer Space", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_09._Outer_Space_preview.mp3" },
            { title: "Let's Ride (rap)", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_10._Let's_Ride_preview.mp3" },
            { title: "It's Gettin Rowdy (rap)", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_11._It's_Gettin_Rowdy_preview.mp3" }
        ]
    },
    { 
        name: "Days Away",
        productId: "9856772079891",
        variantId: "50547489341715",
        cover: "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJCD3_600.jpg?v=1755810199",
        tracks: [
            { title: "Magnetic Moment", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_01._Magnetic_Moment_preview.mp3" },
            { title: "Speaker 1, Speaker 1", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_02._Speaker_1,_Speaker_1_preview.mp3" },
            { title: "Sidetracked", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_03._Sidetracked_preview.mp3" },
            { title: "Early Morning May", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_04._Early_Morning_May_preview.mp3" },
            { title: "Supercell In Tune", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_05._Supercell_In_Tune_preview.mp3" },
            { title: "With Water and Light", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_06._With_Water_and_Light_preview.mp3" },
            { title: "7 Times", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_07._7_Times_preview.mp3" },
            { title: "Red Lemonade", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_08._Red_Lemonade_preview.mp3" },
            { title: "Days Away", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_09._Days_Away_preview.mp3" },
            { title: "Deep-Sea Sounding", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_10._Deep-Sea_Sounding_preview.mp3" },
            { title: "Error Me Out", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_11._Error_Me_Out_preview.mp3" },
            { title: "Piano Wire", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_12._Piano_Wire_preview.mp3" },
            { title: "Simpletank", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_13._Simpletank_preview.mp3" },
            { title: "From The Arrow Loop", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_14._From_The_Arrow_Loop_preview.mp3" },
            { title: "Red Lemonade Remixed", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_15._Red_Lemonade_Remixed_preview.mp3" }
        ]
    },
    { 
        name: "Alpha Numeric",
        productId: "9856758350099",
        variantId: "50547284312339",
        cover: "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJCD4_600_b9515a72-9852-4256-b4db-16592d9bbd91.jpg?v=1755811619",
        tracks: [
            { title: "Synergetics", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_01._Synergetics_preview.mp3" },
            { title: "Filter In", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_02._Filter_In_preview.mp3" },
            { title: "In Blue", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_03._In_Blue_preview.mp3" },
            { title: "Mr. Mac", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_04._Mr._Mac_preview.mp3" },
            { title: "Echo Out", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_05._Echo_Out_preview.mp3" },
            { title: "Alpha Numeric", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_06._Alpha_Numeric_preview.mp3" },
            { title: "Hotel Midi", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_07._Hotel_Midi_preview.mp3" },
            { title: "103 Degrees", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_08._103_Degrees_preview.mp3" },
            { title: "Slow To Spring", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_09._Slow_to_Spring_preview.mp3" },
            { title: "Fall Drift", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_10._Fall_Drift_preview.mp3" },
            { title: "All The Circles", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_11._All_The_Circles_preview.mp3" },
            { title: "Dream Happy", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_12._Dream_Happy_preview.mp3" }
        ]
    },
    { 
        name: "Make It Fun Vol. 1",
        productId: "9864941404435",
        variantId: "50592303612179",
        cover: "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJCD4A_BC_600.jpg?v=1755810203",
        tracks: [
            { title: "Dr. Goose Robbins - No Lead - 125BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_01._Dr._Goose_Robbins_No_Lead_125BPM_preview.mp3" },
            { title: "Dr. Goose Robbins - No Drums - 125BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_02._Dr._Goose_Robbins_No_Drums_125BPM_preview.mp3" },
            { title: "Try The Bass - No Lead - 115BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_03._Try_The_Bass_No_Lead_115BPM_preview.mp3" },
            { title: "Try The Bass - No Drums - 115BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_04._Try_The_Bass_No_Drums_115BPM_preview.mp3" },
            { title: "Alpha Numeric - No Lead - 132BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_05._Alpha_Numeric_No_Lead_132BPM_preview.mp3" },
            { title: "Alpha Numeric - No Drums - 132BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_06._Alpha_Numeric_No_Drums_132BPM_preview.mp3" },
            { title: "Synergetics - No Lead - 130BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_07._Synergetics_No_Lead_130BPM_preview.mp3" },
            { title: "Synergetics - No Drums - 130BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_08._Synergetics_No_Drums_130BPM_preview.mp3" },
            { title: "Guitar Sound - No Guitar - 100BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_09._Guitar_Sound_No_Guitar_100BPM_preview.mp3" },
            { title: "Guitar Sound - No Drums - 100BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_10._Guitar_Sound_No_Drums_100BPM_preview.mp3" },
            { title: "Fall Drift - No Lead Piano - 120BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_11._Fall_Drift_No_Lead_Piano_120BPM_preview.mp3" },
            { title: "Fall Drift - No Drums - 120BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_12._Fall_Drift_No_Drums_120BPM_preview.mp3" },
            { title: "Disorganized Fun - No Lead - 98BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_13._Disorganized_Fun_No_Lead_98BPM_preview.mp3" },
            { title: "Disorganized Fun - No Drums - 98BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_14._Disorganized_Fun_No_Drums_98BPM_preview.mp3" },
            { title: "Throwing Fire - No Lead - 105BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_15._Throwing_Fire_No_Lead_105BPM_preview.mp3" },
            { title: "Throwing Fire - No Drums - 105BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_16._Throwing_Fire_No_Drums_105BPM_preview.mp3" },
            { title: "Stay Crunchy - No Lead - 140BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_17._Stay_Crunchy_No_Lead_140BPM_preview.mp3" },
            { title: "Stay Crunchy - No Drums - 140BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_18._Stay_Crunchy_No_Drums_140BPM_preview.mp3" },
            { title: "Outer Space - No Lead - 117BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_19._Outer_Space_No_Lead_117BPM_preview.mp3" },
            { title: "Outer Space - No Drums - 117BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_20._Outer_Space_No_Drums_117BPM_preview.mp3" }
        ]
    },
    { 
        name: "Rhodes Deep",
        productId: "9855845826835",
        variantId: "50543741927699",
        cover: "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJCD5_600.jpg?v=1755810207",
        tracks: [
            { title: "Rhodes Deep", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_01._Rhodes_Deep_preview.mp3" },
            { title: "Dr. Goose Robbins", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_02._Dr._Goose_Robbins_preview.mp3" },
            { title: "Expensive Ice Chill Cuts Deluxe", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_03._Expensive_Ice_Chill_Cuts_Deluxe_preview.mp3" },
            { title: "Arp Island", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_04._Arp_Island_preview.mp3" },
            { title: "So Alive", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_05._So_Alive_preview.mp3" },
            { title: "So Alive (Instrumental)", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_06._So_Alive_(Instrumental)_preview.mp3" },
            { title: "Unusual Weather", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_07._Unusual_Weather_preview.mp3" },
            { title: "Spearmint", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_08._Spearmint_preview.mp3" },
            { title: "Try The Bass", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_09._Try_The_Bass_preview.mp3" },
            { title: "Aquatic Jambiance", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_10._Aquatic_Jambiance_preview.mp3" }
        ]
    },
    { 
        name: "Wonder And Flow",
        productId: "52301267468563",
        variantId: "52301267468563",
        cover: "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJ5A_600.webp",
        tracks: [
            { title: "Mindful", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_01_Mindful_preview.wav" },
            { title: "Sky Tied", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_02_Sky_Tied_preview.wav" },
            { title: "Wonder And Flow", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_03_Wonder_And_Flow_preview.wav" },
            { title: "Spark", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_04_Spark_preview.wav" },
            { title: "Right Behind You", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_05_Right_Behind_You_preview.wav" },
            { title: "Linden Flower", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_06_Linden_Flower_preview.wav" },
            { title: "Right Behind You 1.5", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_07_Right_Behind_You_1.5_preview.wav" },
            { title: "Nature November", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_08_Nature_November_preview.wav" }
        ]
    }
];

// Apply local cover mapping if provided by Liquid
if (window.RJ_ALBUM_COVERS_BY_NAME) {
    albums = albums.map(a => ({
        ...a,
        cover: window.RJ_ALBUM_COVERS_BY_NAME[a.name] || a.cover
    }));
}

let selectedAlbums = {};
let currentAudio = null;
let currentTrackElement = null;
let currentTrackId = null;
let currentAlbumName = null;
let audioProgressInterval;
let activeAlbum = null;


if (!window.PRICE_DATA) {
    window.PRICE_DATA = {
        "timestamp": new Date().toISOString(),
        "prices": {
            "9856772800787": 40,
            "9856772374803": 40,
            "9856772079891": 40,
            "9856758350099": 40,
            "9864941404435": 20,
            "9855845826835": 40,
            "52301267468563": 20
        }
    };
}

function rjLoadAlbums() {
    const container = document.getElementById("rj-albumContainer");
    if (!container) {
        console.error("RJ Album container not found!");
        return;
    }
    
    container.innerHTML = '';
    
    const albumsToLoad = [...albums].reverse();
    
    albumsToLoad.forEach(album => {
        const wrapper = document.createElement("div");
        wrapper.classList.add("rj-album-wrapper");
        
        const albumDiv = document.createElement("div");
        albumDiv.classList.add("rj-album");
        
        const colors = albumColors[album.name];
        if (colors) {
            albumDiv.dataset.primaryColor = colors.primaryColor;
            albumDiv.dataset.secondaryColor = colors.secondaryColor;
            albumDiv.dataset.textColor = colors.textColor;
            albumDiv.dataset.accentColor = colors.accentColor;
            albumDiv.dataset.year = colors.year;
        }
        
        const tracksHtml = album.tracks ? `
            <div class="rj-album-tracks" onclick="event.stopPropagation();">
                ${album.tracks.map((track, index) => `
                    <div class="rj-track" id="rj-track-${album.productId}-${index}" 
                        onclick="rjPlayPreview('${track.preview}', this, 'rj-track-${album.productId}-${index}', '${album.name}', event)"
                        ontouchend="rjPlayPreview('${track.preview}', this, 'rj-track-${album.productId}-${index}', '${album.name}', event)">
                        <span class="rj-track-number">${(index + 1).toString().padStart(2, '0')}</span>
                        <span class="rj-track-title">${track.title}</span>
                        <div class="rj-audio-wave">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                `).join('')}
            </div>
        ` : '';

        albumDiv.innerHTML = `
            <div class="rj-checkbox-overlay">
                <label>
                    <input type="checkbox" class="rj-album-select-checkbox" value="${album.productId}" onclick="event.stopPropagation();" onchange="rjUpdateSelection(this, event)">
                </label>
            </div>
            <div class="rj-album-image">
                <img src="${album.cover}" alt="${album.name}" onerror="this.onerror=null; this.src=(window.RJ_ALBUM_COVERS_FALLBACK||this.src)">
            </div>
            <div class="rj-album-info">
                <p>${album.name}</p>
                <span class="rj-track-count">${album.tracks ? album.tracks.length : 0}-Track License</span>
            </div>
            <div class="rj-price-tag" data-product-id="${album.productId}" data-track-count="${album.tracks ? album.tracks.length : 0}">
                <span class="rj-price-amount">$40</span>
            </div>
            <div class="rj-play-indicator">
                <svg class="rj-play-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 5v14l11-7z" fill="none" stroke="#888888" stroke-width="1.5" stroke-linejoin="round"/>
                </svg>
            </div>
            ${tracksHtml}
        `;
        
        wrapper.appendChild(albumDiv);
        container.appendChild(wrapper);
    });

    rjUpdatePriceDisplay(window.PRICE_DATA?.prices || {
        "9856772800787": 40,
        "9856772374803": 40,
        "9856772079891": 40,
        "9856758350099": 40,
        "9864941404435": 20,
        "9855845826835": 40,
        "52301267468563": 20
    });

    document.querySelectorAll('.rj-album').forEach(album => {
        album.addEventListener('click', function(event) {
            if (event.target.closest('.rj-checkbox-overlay')) {
                return;
            }

            const wasExpanded = this.classList.contains('rj-expanded');
            const currentlyExpanded = document.querySelector('.rj-album.rj-expanded');

            if (currentlyExpanded && currentlyExpanded !== this) {
                currentlyExpanded.classList.remove('rj-expanded');
                rjStopAudio();
            }

            if (!wasExpanded) {
                this.classList.add('rj-expanding');
                
                setTimeout(() => {
                    this.classList.add('rj-expanded');
                    this.classList.remove('rj-expanding');
                }, 50);
                
                setTimeout(() => {
                    const albumRect = this.getBoundingClientRect();
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    
                    if (albumRect.bottom > window.innerHeight - 200) {
                        const newPosition = scrollTop + albumRect.top - 120;
                        window.scrollTo({
                            top: newPosition,
                            behavior: 'smooth'
                        });
                    }
                }, 300);
                
                event.stopPropagation();
            } else {
                this.classList.add('rj-closing');
                
                setTimeout(() => {
                    this.classList.remove('rj-expanded');
                    
                    setTimeout(() => {
                        this.classList.remove('rj-closing');
                    }, 400);
                    
                    rjStopAudio();
                }, 50);
            }
        });
    });
}

function rjUpdatePriceDisplay(prices) {
    if (!prices) return;
    
    document.querySelectorAll('.rj-price-tag').forEach(priceTag => {
        const productId = priceTag.getAttribute('data-product-id');
        const priceAmount = priceTag.querySelector('.rj-price-amount');
        
        if (!priceAmount) return;
        
        const price = prices[productId];
        
        if (price !== undefined) {
            priceAmount.textContent = `$${Math.round(price)}`;
            priceTag.setAttribute('data-price', price);
        } else {
            priceAmount.textContent = '$40';
        }
    });
    
    rjUpdateSelectionPrices();
}

function rjUpdateSelectionPrices() {
    const selectedAlbums = document.querySelectorAll('.rj-album-select-checkbox:checked');
    if (selectedAlbums.length > 0) {
        rjUpdateSelection(selectedAlbums[0]);
    }
}

function rjUpdateSelection(checkbox, event) {
    if (event) {
        event.stopPropagation();
    }
    
    const albumDiv = checkbox.closest('.rj-album');
    const overlay = albumDiv.querySelector('.rj-checkbox-overlay');
    const selectedAlbumsContainer = document.querySelector('.rj-selected-products');
    const emptyMessage = document.querySelector('.rj-empty-selection-message');
    
    if (checkbox.checked) {
        overlay.classList.add('rj-checked');
        checkbox.setAttribute("data-selected", "true");
        overlay.setAttribute("data-selected", "true");
        
        const colors = albumColors[albumDiv.querySelector('.rj-album-info p').textContent];
        if (colors && colors.primaryColor) {
            albumDiv.style.boxShadow = `0 0 0 2px ${colors.primaryColor}, 0 4px 12px ${colors.primaryColor}33`;
        }
        
        const albumImg = albumDiv.querySelector('img');
        const albumName = albumDiv.querySelector('.rj-album-info p').textContent;
        
        const thumbnail = document.createElement('div');
        thumbnail.classList.add('rj-selected-thumbnail');
        thumbnail.setAttribute('data-product-id', checkbox.value);
        thumbnail.innerHTML = `
            <div style="
                position: relative;
                width: 60px;
                height: 60px;
                border-radius: 8px;
                overflow: hidden;
                box-shadow: 0 0 0 2px ${colors && colors.primaryColor ? colors.primaryColor : '#5e95cb'};
            ">
                <img src="${albumImg.src}" alt="${albumName}" style="width: 100%; height: 100%; object-fit: cover;">
            </div>
        `;
        
        selectedAlbumsContainer.appendChild(thumbnail);
        
        if (emptyMessage) {
            emptyMessage.style.display = 'none';
        }
        
        const subtotalWrapper = document.querySelector('.rj-subtotal-wrapper');
        if (subtotalWrapper) {
            subtotalWrapper.style.display = 'block';
        }
        
    } else {
        overlay.classList.remove('rj-checked');
        checkbox.removeAttribute("data-selected");
        overlay.removeAttribute("data-selected");
        
        albumDiv.style.boxShadow = '0 0 0 2px transparent';
        
        const thumbnail = selectedAlbumsContainer.querySelector(`[data-product-id="${checkbox.value}"]`);
        if (thumbnail) {
            thumbnail.remove();
        }
    }
    
    const selectedCheckboxes = document.querySelectorAll('.rj-album-select-checkbox:checked');
    let totalPrice = 0;
    let totalTracks = 0;
    
    selectedCheckboxes.forEach(cb => {
        const album = cb.closest('.rj-album');
        const priceTag = album.querySelector('.rj-price-tag');
        let price = 0;
        
        if (priceTag && priceTag.hasAttribute('data-price')) {
            price = parseFloat(priceTag.getAttribute('data-price')) || 0;
        } else if (priceTag) {
            const priceAmount = priceTag.querySelector('.rj-price-amount');
            if (priceAmount && priceAmount.textContent) {
                const priceText = priceAmount.textContent.trim();
                if (priceText && !priceText.includes("Loading")) {
                    price = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
                }
            }
        }
        
        totalPrice += price;
        
        const trackCountEl = album.querySelector('.rj-track-count');
        const trackCountText = trackCountEl ? trackCountEl.textContent : '';
        const trackCount = parseInt(trackCountText.match(/\d+/)?.[0] || '0');
        totalTracks += trackCount;
    });
    
    const amountElement = document.querySelector('.rj-total-amount .rj-amount');
    if (amountElement) {
        const oldPrice = parseInt(amountElement.textContent);
        if (oldPrice !== Math.round(totalPrice)) {
            amountElement.classList.add('rj-value-changed');
            setTimeout(() => {
                amountElement.classList.remove('rj-value-changed');
            }, 300);
        }
        amountElement.textContent = Math.round(totalPrice);
    }
    
    const trackCountElement = document.getElementById('rj-trackCount');
    if (trackCountElement) {
        const oldTrackCount = parseInt(trackCountElement.textContent);
        
        if (oldTrackCount !== totalTracks) {
            trackCountElement.classList.add('rj-value-changed');
            setTimeout(() => {
                trackCountElement.classList.remove('rj-value-changed');
            }, 300);
        }
        
        trackCountElement.textContent = totalTracks;
    }
    
    if (emptyMessage) {
        emptyMessage.style.display = selectedCheckboxes.length === 0 ? 'block' : 'none';
    }
    
    const orderSummarySection = document.getElementById('rj-order-summary-section');
    if (orderSummarySection) {
        orderSummarySection.style.display = selectedCheckboxes.length === 0 ? 'none' : 'block';
    }
    
    const subtotalWrapper = document.querySelector('.rj-subtotal-wrapper');
    if (subtotalWrapper) {
        subtotalWrapper.style.display = selectedCheckboxes.length === 0 ? 'none' : 'block';
    }
    
    const addToCartBtn = document.getElementById('rj-addToCartBtn');
    if (addToCartBtn) {
        addToCartBtn.disabled = selectedCheckboxes.length === 0;
    }
}


function rjPlayPreview(url, trackElement, trackId, albumName, event) {
    if (event) {
        event.stopPropagation();
        if (event.type === 'touchend') {
            event.preventDefault();
        }
    }
    
    const album = trackElement.closest('.rj-album');
    if (album && !album.classList.contains('rj-expanded')) {
        album.classList.add('rj-expanded');
    }
    
    const track = typeof trackElement === 'string' ? document.getElementById(trackElement) : trackElement;
    
    if (currentAudio && currentAudio.src === url) {
        if (currentAudio.paused) {
            try {
                currentAudio.load();
                const playPromise = currentAudio.play();
                
                if (playPromise !== undefined) {
                    playPromise
                    .then(() => {
                        track.classList.add('rj-playing');
                    })
                    .catch(error => {
                        console.error("Error resuming audio:", error);
                        track.classList.remove('rj-playing');
                        rjShowPlaybackError(track, "Tap again to play");
                    });
                }
            } catch (e) {
                console.error("Exception during audio playback:", e);
                track.classList.remove('rj-playing');
            }
        } else {
            currentAudio.pause();
            track.classList.remove('rj-playing');
        }
        return;
    }

    rjStopAudio();
    
    currentAudio = new Audio(url);
    currentAudio.preload = 'auto';
    
    let progressBar = track.querySelector('.rj-progress-bar');
    if (!progressBar) {
        progressBar = document.createElement('div');
        progressBar.className = 'rj-progress-bar';
        progressBar.id = trackId ? trackId + '-progress' : 'rj-track-progress-' + Math.random().toString(36).substr(2, 9);
        progressBar.style.cssText = `
            width: 0%;
            height: 3px;
            background-color: #5e95cb;
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 2;
            will-change: width;
            transform: translateZ(0);
            backface-visibility: hidden;
        `;
        track.style.position = 'relative';
        track.appendChild(progressBar);
    } else {
        progressBar.style.width = '0%';
    }
    
    currentAudio.progressId = progressBar.id;
    
    currentAudio.addEventListener('timeupdate', rjUpdateProgress);
    currentAudio.addEventListener('ended', () => {
        track.classList.remove('rj-playing');
        rjStopAudio();
    });

    currentAudio.addEventListener('error', (e) => {
        console.error("Audio error:", e);
        track.classList.remove('rj-playing');
        rjShowPlaybackError(track, "Audio error - try again");
    });

    track.classList.add('rj-attempting-play');
    
    try {
        currentAudio.load();
        const playPromise = currentAudio.play();
        
        if (playPromise !== undefined) {
            playPromise
            .then(() => {
                track.classList.remove('rj-attempting-play');
                track.classList.add('rj-playing');
                
                // Trigger background color transition using shared background system
                if (albumName && window.rjSharedBackground) {
                    window.rjSharedBackground.transitionToAlbum(albumName);
                }
            })
            .catch((error) => {
                console.error("Error playing audio:", error);
                track.classList.remove('rj-attempting-play');
                track.classList.remove('rj-playing');
                
                rjShowPlaybackError(track, "Tap to play");
                
                const retryPlay = function(e) {
                    e.stopPropagation();
                    if (e.type === 'touchend') {
                        e.preventDefault();
                    }
                    
                    track.classList.add('rj-attempting-play');
                    currentAudio.load();
                    currentAudio.play()
                        .then(() => {
                            track.classList.remove('rj-attempting-play');
                            track.classList.add('rj-playing');
                            track.removeEventListener('click', retryPlay);
                            track.removeEventListener('touchend', retryPlay);
                        })
                        .catch((innerError) => {
                            console.error("Retry failed:", innerError);
                            track.classList.remove('rj-attempting-play');
                            track.classList.remove('rj-playing');
                        });
                };
                
                track.addEventListener('click', retryPlay, { once: true });
                track.addEventListener('touchend', retryPlay, { once: true });
            });
        }
    } catch (e) {
        console.error("Exception during audio playback:", e);
        track.classList.remove('rj-attempting-play');
        track.classList.remove('rj-playing');
        rjShowPlaybackError(track, "Audio error");
    }
}

function rjShowPlaybackError(trackElement, message) {
    const existingError = trackElement.querySelector('.rj-playback-error');
    if (existingError) {
        existingError.remove();
    }
    
    const errorMsg = document.createElement('div');
    errorMsg.className = 'rj-playback-error';
    errorMsg.textContent = message;
    errorMsg.style.cssText = `
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        color: #ff5252;
        font-size: 12px;
        font-weight: 500;
        padding: 4px 8px;
        border-radius: 4px;
        background: rgba(255,255,255,0.9);
        z-index: 3;
        will-change: opacity;
        transform: translateY(-50%) translateZ(0);
    `;
    
    trackElement.appendChild(errorMsg);
    
    setTimeout(() => {
        if (errorMsg.parentNode === trackElement) {
            errorMsg.remove();
        }
    }, 3000);
}

function rjStopAudio() {
    if (currentAudio) {
        currentAudio.pause();
        currentAudio.currentTime = 0;
        document.querySelectorAll('.rj-track.rj-playing').forEach(track => {
            track.classList.remove('rj-playing');
        });
        currentAudio = null;
    }
}

let lastProgressUpdate = 0;
const PROGRESS_THROTTLE = 100;

function rjUpdateProgress() {
    if (!currentAudio || !currentAudio.progressId) return;
    
    const now = Date.now();
    if (now - lastProgressUpdate < PROGRESS_THROTTLE) return;
    lastProgressUpdate = now;
    
    requestAnimationFrame(() => {
        const progressElement = document.getElementById(currentAudio.progressId);
        if (!progressElement) return;
        const progress = (currentAudio.currentTime / currentAudio.duration) * 100;
        progressElement.style.width = `${progress}%`;
    });
}

function rjCloseAlbum(event) {
    event.stopPropagation();
    const album = event.target.closest('.rj-album');
    if (album) {
        album.classList.remove('rj-expanded');
        rjStopAudio();
    }
}

function rjValidateCheckout() {
    const selectedAlbums = document.querySelectorAll(".rj-album-select-checkbox:checked");
    
    if (selectedAlbums.length === 0) {
        rjShowToast("Please select at least one album to license.", "error");
        
        const albumContainer = document.getElementById('rj-albumContainer');
        if (albumContainer) {
            albumContainer.style.boxShadow = '0 0 0 2px #f44336';
            albumContainer.style.transition = 'box-shadow 0.3s ease';
            
            if (window.innerWidth <= 480) {
                window.scrollTo({
                    top: albumContainer.offsetTop - 60,
                    behavior: 'smooth'
                });
            } else {
                albumContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            
            setTimeout(() => {
                albumContainer.style.boxShadow = '';
            }, 2000);
        }
        
        return false;
    }
    
    rjAddToShopifyCart();
    return true;
}

function rjAddToShopifyCart() {
    try {
        const selectedCheckboxes = document.querySelectorAll(".rj-album-select-checkbox:checked");
        
        if (selectedCheckboxes.length === 0) {
            rjShowToast("Please select at least one album.", "error");
            return;
        }

        const channelNameEl = document.getElementById("rj-channelName");
        const youtubeUrlEl = document.getElementById("primaryChannelUrl");
        const secondaryChannelNameEl = document.getElementById("rj-secondaryChannelName");
        const additionalUrlEl = document.getElementById("rj-additionalUrl");
        const yourNameEl = document.getElementById("rj-yourName");
        const yourEmailEl = document.getElementById("rj-yourEmail");
        
        const channelName = channelNameEl ? channelNameEl.value.trim() : '';
        const youtubeUrl = youtubeUrlEl ? youtubeUrlEl.value.trim() : '';
        const secondaryChannelName = secondaryChannelNameEl ? secondaryChannelNameEl.value.trim() : '';
        const additionalUrl = additionalUrlEl ? additionalUrlEl.value.trim() : '';
        const yourName = yourNameEl ? yourNameEl.value.trim() : '';
        const yourEmail = yourEmailEl ? yourEmailEl.value.trim() : '';
        
        if (!channelName) {
            rjShowValidationError(channelNameEl, "Primary Channel Name is required");
            return;
        }
        
        if (!youtubeUrl) {
            rjShowValidationError(youtubeUrlEl, "Primary Channel URL is required");
            return;
        }
        
        if (!rjIsValidUrl(youtubeUrl)) {
            rjShowValidationError(youtubeUrlEl, "Please enter a valid URL");
            return;
        }
        
        if (secondaryChannelName && !additionalUrl) {
            rjShowValidationError(additionalUrlEl, "Secondary URL is required when Secondary Channel Name is provided");
            return;
        }
        
        if (additionalUrl && !secondaryChannelName) {
            rjShowValidationError(secondaryChannelNameEl, "Secondary Channel Name is required when Secondary URL is provided");
            return;
        }
        
        if (additionalUrl && !rjIsValidUrl(additionalUrl)) {
            rjShowValidationError(additionalUrlEl, "Please enter a valid URL");
            return;
        }
        
        if (yourEmail && !rjIsValidEmail(yourEmail)) {
            rjShowValidationError(yourEmailEl, "Please enter a valid email address");
            return;
        }

        const cartItems = [];
        
        const variantMap = {
            "9856772800787": "50547500941587", // Ronald Jenkees
            "9856772374803": "50547493273875", // Disorganized Fun
            "9856772079891": "50547489341715", // Days Away
            "9856758350099": "50547284312339", // Alpha Numeric
            "9864941404435": "50592303612179", // Make It Fun Vol. 1
            "9855845826835": "50543741927699",  // Rhodes Deep
            "52301267468563": "52301267468563"  // Wonder And Flow (RJ-5A License) - provisional
        };
        
        let noteData = [];
        noteData.push(`primaryChannel:${channelName}`);
        noteData.push(`primaryUrl:${youtubeUrl}`);
        
        if (secondaryChannelName) {
            noteData.push(`secondaryChannel:${secondaryChannelName}`);
        }
        
        if (additionalUrl) {
            noteData.push(`secondaryUrl:${additionalUrl}`);
        }
        
        if (yourName) {
            noteData.push(`name:${yourName}`);
        }
        
        if (yourEmail) {
            noteData.push(`email:${yourEmail}`);
        }
        
        const orderNote = noteData.join(', ');
        
        selectedCheckboxes.forEach(checkbox => {
            const productId = checkbox.value;
            const variantId = variantMap[productId] || productId;
            
            cartItems.push({
                id: variantId,
                quantity: 1
            });
        });

        rjSaveFormData();
        
        fetch('/cart.js')
        .then(response => response.json())
        .then(currentCart => {
            const variantMap = {
                "9856772800787": "50547500941587", // Ronald Jenkees
                "9856772374803": "50547493273875", // Disorganized Fun
                "9856772079891": "50547489341715", // Days Away
                "9856758350099": "50547284312339", // Alpha Numeric
                "9864941404435": "50592303612179", // Make It Fun Vol. 1
                "9855845826835": "50543741927699",  // Rhodes Deep
                "52301267468563": "52301267468563"  // Wonder And Flow (RJ-5A License) - provisional
            };
            
            const selectedVariantIds = new Set(cartItems.map(item => item.id));
            const existingLicenseItems = [];
            
            if (currentCart.items && currentCart.items.length > 0) {
                currentCart.items.forEach(item => {
                    // Check if this variant is one of our license variants
                    if (Object.values(variantMap).includes(item.variant_id.toString())) {
                        existingLicenseItems.push({
                            id: item.id,
                            variant_id: item.variant_id.toString(),
                            quantity: item.quantity
                        });
                    }
                });
            }
            
            
            const operations = [];
            if (existingLicenseItems.length > 0) {
                existingLicenseItems.forEach(item => {
                    operations.push({
                        type: 'remove',
                        data: {
                            id: item.id,
                            quantity: 0
                        }
                    });
                });
            }
            
            if (cartItems.length > 0) {
                operations.push({
                    type: 'add',
                    data: {
                        items: cartItems
                    }
                });
            }
            
            if (operations.length === 0) {
                rjShowToast("Your selections are ready for checkout!", "success");
                setTimeout(() => {
                    window.location.href = '/checkout';
                }, 1000);
                return Promise.resolve(null);
            }
            
            let statusMessage = "";
            const itemsToAdd = cartItems.filter(item => !existingLicenseItems.some(existing => existing.variant_id === item.id));
            const itemsToRemove = existingLicenseItems.filter(item => !cartItems.some(cart => cart.id === item.variant_id));
            
            if (existingLicenseItems.length > 0 && cartItems.length > 0) {
                statusMessage = `Updating ${cartItems.length} albums in cart...`;
            } else if (cartItems.length > 0) {
                statusMessage = `Adding ${cartItems.length} albums to cart...`;
            } else if (existingLicenseItems.length > 0) {
                statusMessage = `Removing ${existingLicenseItems.length} albums from cart...`;
            }
            rjShowToast(statusMessage, "success");
            
            // Execute operations sequentially with order note
            return rjExecuteCartOperations(operations, orderNote);
        })
        .then(result => {
            if (result !== null) {
                // Redirect to checkout after operations complete
                window.location.href = '/checkout';
            }
        })
        .catch(error => {
            console.error('Error with cart synchronization:', error);
            rjShowToast("Error updating cart. Please try again.", "error");
        });

    } catch (err) {
        console.error('Cart error:', err);
        rjShowToast("An error occurred. Please try again.", "error");
    }
}

function rjShowValidationError(inputElement, message) {
    if (!inputElement) return;
    
    rjClearValidationErrors();
    
    inputElement.classList.add('rj-validation-error');
    inputElement.style.borderColor = '#f44336';
    
    const errorMessage = document.createElement('div');
    errorMessage.className = 'rj-validation-error-message';
    errorMessage.textContent = message;
    errorMessage.style.cssText = `
        color: #f44336;
        font-size: 12px;
        margin-top: 4px;
        font-weight: 500;
    `;
    
    if (window.innerWidth <= 480) {
        errorMessage.style.cssText += `
            background-color: rgba(244, 67, 54, 0.05);
            padding: 6px 8px;
            border-radius: 4px;
            font-size: 13px;
            display: block;
            width: 100%;
        `;
    }
    
    inputElement.parentNode.appendChild(errorMessage);
    
    const scrollOptions = window.innerWidth <= 480 
        ? { behavior: 'smooth', block: 'center', inline: 'nearest' }
        : { behavior: 'smooth', block: 'center' };
        
    setTimeout(() => {
        inputElement.scrollIntoView(scrollOptions);
    }, 100);
    
    inputElement.addEventListener('input', function() {
        inputElement.classList.remove('rj-validation-error');
        inputElement.style.borderColor = '';
        const errorMsg = inputElement.parentNode.querySelector('.rj-validation-error-message');
        if (errorMsg) {
            errorMsg.remove();
        }
    }, { once: true });
}

function rjClearValidationErrors() {
    document.querySelectorAll('.rj-validation-error').forEach(input => {
        input.classList.remove('rj-validation-error');
        input.style.borderColor = '';
    });
    
    document.querySelectorAll('.rj-validation-error-message').forEach(message => {
        message.remove();
    });
}

function rjIsValidUrl(url) {
    if (!url) return false;
    
    url = url.trim();
    
    if (url.includes(' ')) return false;
    if (url.length < 4) return false;
    if (!url.includes('.')) return false;
    
    const hasValidDomain = /\.[a-zA-Z]{2,}/.test(url);
    if (!hasValidDomain) return false;
    
    try {
        new URL(url);
        return true;
    } catch {
        if (!url.match(/^[a-zA-Z]+:\/\//)) {
            try {
                new URL('https://' + url);
                return true;
            } catch {
                return false;
            }
        }
        return false;
    }
}

function rjIsValidEmail(email) {
    if (!email) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function rjShowToast(message, type = "") {
    const toast = document.getElementById("rj-toast");
    if (!toast) return;
    
    toast.textContent = message;
    toast.className = `rj-toast ${type}`;
    toast.style.display = "block";
    toast.classList.add("rj-show");
    
    setTimeout(() => {
        if (toast) {
            toast.classList.remove("rj-show");
            setTimeout(() => {
                toast.style.display = "none";
            }, 300);
        }
    }, 3000);
}

function rjPrefillUrl(prefix, customPlaceholder) {
    const urlInput = document.getElementById('rj-youtubeUrl');
    if (urlInput) {
        const originalBlurHandler = urlInput.onblur;
        urlInput.onblur = null;
        
        urlInput.value = prefix;
        urlInput.focus();
        
        if (customPlaceholder) {
            urlInput.placeholder = customPlaceholder;
        } else if (prefix === '') {
            urlInput.placeholder = "e.g., youtube.com/@ronaldjenkees";
        }
        
        const length = prefix.length;
        if (urlInput.setSelectionRange) {
            urlInput.setSelectionRange(length, length);
        }
        
        rjClearValidationErrors();
        
        setTimeout(() => {
            urlInput.onblur = originalBlurHandler;
        }, 150);
    }
}

function rjPrefillSecondaryUrl(prefix, customPlaceholder) {
    const urlInput = document.getElementById('rj-additionalUrl');
    if (urlInput) {
        const originalBlurHandler = urlInput.onblur;
        urlInput.onblur = null;
        
        urlInput.value = prefix;
        urlInput.focus();
        
        if (customPlaceholder) {
            urlInput.placeholder = customPlaceholder;
        } else if (prefix === '') {
            urlInput.placeholder = "e.g., twitch.tv/bobross";
        }
        
        const length = prefix.length;
        if (urlInput.setSelectionRange) {
            urlInput.setSelectionRange(length, length);
        }
        
        rjClearValidationErrors();
        
        setTimeout(() => {
            urlInput.onblur = originalBlurHandler;
        }, 150);
    }
}

function rjToggleSection(sectionId) {
    const section = document.getElementById(sectionId);
    const toggleIcon = document.getElementById(sectionId === 'rj-secondary-fields' ? 'rj-secondary-toggle' : 'rj-personal-toggle');
    const fieldGroup = section?.closest('.rj-field-group.rj-optional-fields');
    
    if (!section) return;
    
    if (section.dataset.transitioning === 'true') {
        return;
    }
    
    section.dataset.transitioning = 'true';
    
    const isCurrentlyHidden = section.style.display === 'none' || !section.style.display;
    
    if (isCurrentlyHidden) {
        section.style.display = 'block';
        if (toggleIcon) toggleIcon.textContent = '▲';
        if (fieldGroup) fieldGroup.classList.add('rj-expanded');
    } else {
        section.style.display = 'none';
        if (toggleIcon) toggleIcon.textContent = '▼';
        if (fieldGroup) fieldGroup.classList.remove('rj-expanded');
    }
    
    setTimeout(() => {
        section.dataset.transitioning = 'false';
    }, 300);
}

function rjSwitchTab(tabId) {
    document.querySelectorAll('.rj-tab-button').forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
    });
    
    document.querySelectorAll('.rj-tab-indicator').forEach(ind => {
        ind.classList.remove('active');
    });
    
    document.querySelectorAll('.rj-tab-pane').forEach(pane => {
        pane.classList.remove('active');
    });
    
    const activeButton = document.querySelector(`[onclick="rjSwitchTab('${tabId}')"]`);
    if (activeButton) {
        activeButton.classList.add('active');
        activeButton.setAttribute('aria-selected', 'true');
        
        const buttons = Array.from(document.querySelectorAll('.rj-tab-button'));
        const activeIndex = buttons.indexOf(activeButton);
        
        const indicators = document.querySelectorAll('.rj-tab-indicator');
        if (indicators[activeIndex]) {
            indicators[activeIndex].classList.add('active');
        }
    }
    
    const contentPane = document.getElementById(tabId);
    if (contentPane) {
        contentPane.classList.add('active');
    }
}

async function rjExecuteCartOperations(operations, orderNote = null) {
    try {
        const updates = {};
        let hasRemoveOperations = false;
        let addItems = [];
        
        for (const operation of operations) {
            if (operation.type === 'remove') {
                updates[operation.data.id] = 0;
                hasRemoveOperations = true;
            } else if (operation.type === 'add') {
                addItems = addItems.concat(operation.data.items);
            }
        }
        
        if (hasRemoveOperations) {
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ updates })
            });
        }
        
        if (addItems.length > 0) {
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ items: addItems })
            });
        }
        
        if (orderNote) {
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ note: orderNote })
            });
        }
        
        return true;
    } catch (error) {
        console.error('Error executing cart operations:', error);
        throw error;
    }
}

async function rjSyncCartState() {
    try {
        const response = await fetch('/cart.js');
        if (!response.ok) return;
        
        const cart = await response.json();
        if (!cart.items || cart.items.length === 0) return;
        
        const productMap = {
            "50547500941587": "9856772800787", // Ronald Jenkees
            "50547493273875": "9856772374803", // Disorganized Fun
            "50547489341715": "9856772079891", // Days Away
            "50547284312339": "9856758350099", // Alpha Numeric
            "50592303612179": "9864941404435", // Make It Fun Vol. 1
            "50543741927699": "9855845826835"  // Rhodes Deep
        };
        
        const licenseItemsInCart = cart.items.filter(item => 
            Object.keys(productMap).includes(item.variant_id.toString())
        );
        
        if (licenseItemsInCart.length === 0) return;
        
        licenseItemsInCart.forEach(cartItem => {
            const productId = productMap[cartItem.variant_id.toString()];
            const checkbox = document.querySelector(`.rj-album-select-checkbox[value="${productId}"]`);
            
            if (checkbox && !checkbox.checked) {
                checkbox.checked = true;
                // Trigger the update selection function to update UI
                rjUpdateSelection(checkbox);
            }
        });
        
        if (licenseItemsInCart.length > 0) {
            const message = licenseItemsInCart.length === 1 
                ? "✅ 1 license from your cart has been selected" 
                : `✅ ${licenseItemsInCart.length} licenses from your cart have been selected`;
            
            // Show a helpful toast with checkmark
            setTimeout(() => {
                rjShowToast(message, "success");
            }, 1000);
        }
        
    } catch (error) {
        console.log('Cart sync info:', error);
    }
}

// Form persistence functions - Mobile-safe with progressive enhancement
function rjStorageAvailable() {
    try {
        const test = '__rj_storage_test__';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch(e) {
        return false;
    }
}

function rjSafeStorageOperation(operation) {
    if (!rjStorageAvailable()) return false;
    
    try {
        return operation();
    } catch(e) {
        console.log('Storage unavailable, continuing without persistence');
        return false;
    }
}

function rjGatherFormData() {
    return {
        channelName: document.getElementById('rj-channelName')?.value?.trim() || '',
        youtubeUrl: document.getElementById('primaryChannelUrl')?.value?.trim() || '',
        secondaryChannelName: document.getElementById('rj-secondaryChannelName')?.value?.trim() || '',
        additionalUrl: document.getElementById('rj-additionalUrl')?.value?.trim() || '',
        yourName: document.getElementById('rj-yourName')?.value?.trim() || '',
        yourEmail: document.getElementById('rj-yourEmail')?.value?.trim() || ''
    };
}

function rjShouldSaveForm(formData) {
    return formData.channelName.length > 2 && formData.youtubeUrl.length > 5;
}

function rjIsDataFresh(timestamp) {
    const FORTY_EIGHT_HOURS = 48 * 60 * 60 * 1000;
    return (Date.now() - timestamp) < FORTY_EIGHT_HOURS;
}

function rjSaveFormData() {
    const formData = rjGatherFormData();
    
    if (!rjShouldSaveForm(formData)) return;
    
    rjSafeStorageOperation(() => {
        const dataToSave = {
            ...formData,
            timestamp: Date.now()
        };
        localStorage.setItem('rj-form-data', JSON.stringify(dataToSave));
        return true;
    });
}

function rjPopulateFields(data) {
    const fields = [
        { id: 'rj-channelName', value: data.channelName },
        { id: 'primaryChannelUrl', value: data.youtubeUrl },
        { id: 'rj-secondaryChannelName', value: data.secondaryChannelName },
        { id: 'rj-additionalUrl', value: data.additionalUrl },
        { id: 'rj-yourName', value: data.yourName },
        { id: 'rj-yourEmail', value: data.yourEmail }
    ];
    
    fields.forEach(field => {
        const element = document.getElementById(field.id);
        if (element && field.value) {
            element.value = field.value;
        }
    });
}

function rjRestoreFormData() {
    rjSafeStorageOperation(() => {
        const saved = localStorage.getItem('rj-form-data');
        if (saved) {
            try {
                const data = JSON.parse(saved);
                if (data.timestamp && rjIsDataFresh(data.timestamp)) {
                    rjPopulateFields(data);
                } else {
                    localStorage.removeItem('rj-form-data');
                }
            } catch(e) {
                localStorage.removeItem('rj-form-data');
            }
        }
        return true;
    });
}

function rjClearFormData() {
    rjSafeStorageOperation(() => {
        localStorage.removeItem('rj-form-data');
        return true;
    });
}

// Logo interaction functions for responsive hover and click effects
function rjInitializeLogoInteractions() {
    const logoElements = document.querySelectorAll('.rj-partner-logo');
    const defaultTargetLicenseItem = Array.from(document.querySelectorAll('.rj-license-item')).find(item => 
        item.textContent.includes('Permanent, worldwide rights across your primary brand'));
    const phoneTargetLicenseItem = Array.from(document.querySelectorAll('.rj-license-item')).find(item => 
        item.textContent.includes('Customer communication channels: Permitted use in your primary brand'));

    if (!logoElements.length) return;

    logoElements.forEach((logo, index) => {
        // Determine which text to highlight based on the logo
        // Index 0 is Hold Music (phone-related), so it should highlight the customer communication text
        const targetLicenseItem = (index === 0) ? phoneTargetLicenseItem : defaultTargetLicenseItem;

        // Handle mouse hover events
        logo.addEventListener('mouseenter', function() {
            if (targetLicenseItem) {
                targetLicenseItem.classList.add('rj-highlighted');
            }
        });

        logo.addEventListener('mouseleave', function() {
            if (targetLicenseItem) {
                targetLicenseItem.classList.remove('rj-highlighted');
            }
        });

        // Handle click events with brief highlight animation
        logo.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Add click animation class
            this.classList.add('rj-logo-clicked');
            
            // Ensure text highlighting during click animation
            if (targetLicenseItem) {
                targetLicenseItem.classList.add('rj-highlighted');
            }
            
            // Remove click class after animation completes (matches CSS animation duration)
            setTimeout(() => {
                this.classList.remove('rj-logo-clicked');
                
                // Remove text highlighting if not hovering
                if (targetLicenseItem && !this.matches(':hover')) {
                    targetLicenseItem.classList.remove('rj-highlighted');
                }
            }, 800); // Matches the CSS animation duration
        });

        // Handle touch events for mobile
        logo.addEventListener('touchstart', function(e) {
            e.preventDefault();
            if (targetLicenseItem) {
                targetLicenseItem.classList.add('rj-highlighted');
            }
        }, { passive: false });

        logo.addEventListener('touchend', function(e) {
            e.preventDefault();
            
            // Add click animation class
            this.classList.add('rj-logo-clicked');
            
            // Remove click class after animation completes
            setTimeout(() => {
                this.classList.remove('rj-logo-clicked');
                if (targetLicenseItem) {
                    targetLicenseItem.classList.remove('rj-highlighted');
                }
            }, 800);
        }, { passive: false });

        // Fallback touch cancel
        logo.addEventListener('touchcancel', function() {
            if (targetLicenseItem) {
                targetLicenseItem.classList.remove('rj-highlighted');
            }
        });
    });
}

/**
 * Initialize when DOM is loaded
 * Fix: close braces correctly and keep listeners within the DOMContentLoaded scope.
 */
document.addEventListener('DOMContentLoaded', function() {
    if (document.getElementById('rj-albumContainer')) {
        rjLoadAlbums();

        setTimeout(() => {
            const nameField = document.getElementById('rj-yourName');
            const emailField = document.getElementById('rj-yourEmail');
            if (nameField && (nameField.value.includes('Custom') || nameField.value.includes('First') || nameField.value.includes('Last'))) {
                nameField.value = '';
            }
            if (emailField && (emailField.value.includes('Custom') || emailField.value.includes('@custom') || emailField.value.includes('custom'))) {
                emailField.value = '';
            }
        }, 50);

        setTimeout(() => { rjRestoreFormData(); }, 100);
        setTimeout(() => { rjSyncCartState(); }, 500);
        // Initialize logo interactions after a brief delay to ensure DOM is ready
        setTimeout(() => { rjInitializeLogoInteractions(); }, 200);

        setTimeout(() => {
            const el = document.getElementById('rj-channelName');
            if (el) {
                try {
                    el.focus({ preventScroll: true });
                    const v = el.value || '';
                    el.setSelectionRange(v.length, v.length);
                } catch (_) {
                    el.focus();
                }
            }
        }, 250);

        function rjUpdateFieldCompletionState(input) {
            const formGroup = input.closest('.rj-form-group');
            if (!formGroup) return;
            const hasContent = input.value.trim().length > 0;
            if (hasContent) {
                formGroup.classList.add('rj-field-completed');
            } else {
                formGroup.classList.remove('rj-field-completed');
            }
        }

        document.querySelectorAll('input').forEach(input => {
            if (input.type !== 'checkbox') {
                input.addEventListener('focus', function() {
                    this.classList.add('rj-input-focused');
                    this.style.borderColor = '#5e95cb';
                    this.style.boxShadow = '0 0 0 2px rgba(94, 149, 203, 0.15)';
                });

                input.addEventListener('blur', function() {
                    this.classList.remove('rj-input-focused');
                    this.style.borderColor = '';
                    this.style.boxShadow = '';
                    rjUpdateFieldCompletionState(this);
                });

                input.addEventListener('input', function() {
                    rjUpdateFieldCompletionState(this);
                });
            }
        });

        // Initialize completion states for fields that already have values
        document.querySelectorAll('input[type="text"], input[type="email"]').forEach(input => {
            rjUpdateFieldCompletionState(input);
        });

        document.body.addEventListener('click', function(event) {
            const expandedAlbum = document.querySelector('.rj-album.rj-expanded');
            if (expandedAlbum && !event.target.closest('.rj-album')) {
                expandedAlbum.classList.remove('rj-expanded');
                rjStopAudio();
            }
        });
    }
});
(function(){
  function s(){
    var c=document.querySelector('.rj-greeting');
    if(!c) return;
    var cs=getComputedStyle(c);
    var f=parseFloat(cs.fontSize);
    if(!isNaN(f) && f>0){
      c.style.setProperty('font-size',(f*1.3)+'px','important');
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',s);}else{s();}
})();
